import { createTracker } from 'usage-tracker';
import events from 'FormsUI/events.yaml';
import { setPrimaryTracker } from 'usage-tracker-container';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
const trackerInstance = createTracker({
  events
});
setPrimaryTracker(trackerInstance, REPORTING_TRACKER);
export default createTracker({
  events,
  properties: {
    namespace: 'forms'
  },
  lastKnownEventProperties: ['screen', 'subscreen']
});